import React, { useState } from "react";
import { Button, Menu, MenuItem, Box } from "@mui/material";
import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import { useTranslation } from "react-i18next";

const ExportButton = ({ handleExport }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (lang) => {
    handleExport(lang);
    handleClose();
  };

  return (
    <Box>
      <MDButton
        color="primary"
        onClick={handleClick}
        sx={{
          "@media (max-width: 600px)": {
            width: "100%", // Full width on small screens
          },
        }}
      >
        {t("export")}
      </MDButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={() => handleSelect(0)}>{t("user.profile.english")}</MenuItem>
        <MenuItem onClick={() => handleSelect(1)}>{t("user.profile.arabic")}</MenuItem>
        <MenuItem onClick={() => handleSelect(3)}>{t("admin.jobs.exportJobDetailsExcel")}</MenuItem>
      </Menu>
    </Box>
  );
};

ExportButton.propTypes = {
  handleExport: PropTypes.func.isRequired,
};

export default ExportButton;
